
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqqk_45egmhR_f8TXT3GGoYGDUcS3c2Ym9WEsltc7nRHJtQMeta } from "/codebuild/output/src2334194962/src/src/pages/faq.vue?macro=true";
import { default as menuLL3w8MX2GXeE2T96lcXsv4cAvhMQogyTzthUZHCXSdAMeta } from "/codebuild/output/src2334194962/src/src/pages/menu.vue?macro=true";
import { default as index1pDc0ByRJtz6p37NdQN93wJL__8TVqdqVQtMyp4zzYgMeta } from "/codebuild/output/src2334194962/src/src/pages/index.vue?macro=true";
import { default as contactQCs4zpjqNrugv45ftTQEFkLKrspVl0ZSZUnUni1iEZYMeta } from "/codebuild/output/src2334194962/src/src/pages/contact.vue?macro=true";
import { default as tutorialLmpMEpuxU7iyOnNoKsBizbYrcdOHITz0ieNnbu9ZVRYMeta } from "/codebuild/output/src2334194962/src/src/pages/tutorial.vue?macro=true";
import { default as agreement7lhcOFS6fU7v8jEx9NU_45sRBYLitkfCh__45p6H7b4BEl0Meta } from "/codebuild/output/src2334194962/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass7pzUnvWH0a6433gNC69cjg2nvCQuiebOHRl8ijwHGBEMeta } from "/codebuild/output/src2334194962/src/src/pages/about-pass.vue?macro=true";
import { default as indexEmPckKAxoy3ijr5RCEuZoSCPHtyRYSkj8HGoT9zQBDwMeta } from "/codebuild/output/src2334194962/src/src/pages/card/index.vue?macro=true";
import { default as _91id_9306ga2bLwwyoVp0tBQdtvI5Ad8qjnBXlmT8sMsSPfNcUMeta } from "/codebuild/output/src2334194962/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceyV8oZ_BkZrcWVY9DwUhkwwoK_45WADRYFsRBtH9peklxUMeta } from "/codebuild/output/src2334194962/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93TlDrs5889QNjC_YU_45mAUZCUrFl3Jyf7BoPSAbqFxuQQMeta } from "/codebuild/output/src2334194962/src/src/pages/notice/[id].vue?macro=true";
import { default as index5fJzqbIIoPpNDRcLavM1wuPhXBojEhD3Y2oiX3eAtMkMeta } from "/codebuild/output/src2334194962/src/src/pages/coupon/index.vue?macro=true";
import { default as indexWLuaBVCVwGnPDysYE_45mzJV__NGy5FyY56bBs_tJRllMMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/index.vue?macro=true";
import { default as indexknVndf75oVpcN2QA1PJOSf0Trv5eqYUMpjSiAF6dfUIMeta } from "/codebuild/output/src2334194962/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93qoe6la201W5zQdfVk3bn4rc3uin_45tbZTQLsMB40tto4Meta } from "/codebuild/output/src2334194962/src/src/pages/parking/[id].vue?macro=true";
import { default as index3aa5TslLsZsTysasxfQ6ktTwQao87WkglGeieNjnC2cMeta } from "/codebuild/output/src2334194962/src/src/pages/history/index.vue?macro=true";
import { default as indexI0tdFDIz9Di7sds9zRDKjdElXpfBvzaB7A7YThMxF7YMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/index.vue?macro=true";
import { default as indexVyD3Z9awfH8iMURNHTBOTawkDtqI5q19_45dYlFlHmTFcMeta } from "/codebuild/output/src2334194962/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexdlOBfFsVtq_45agZchVQQvuN8qYnpY6rTI1Tk717kWIUEMeta } from "/codebuild/output/src2334194962/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavik7NW7JP9dXDStxG1QxnQhJxebr5g7NneUas8D6eE3KYMeta } from "/codebuild/output/src2334194962/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editqnMHMCvdbVDQ8wcgPfcTnIKAqZTMc_45QuCbFCXRFHvtwMeta } from "/codebuild/output/src2334194962/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement2zBZyTxjfgUodqgVdkzWHpghaeSimq4B7P68bUvymxkMeta } from "/codebuild/output/src2334194962/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexMQlF0dw0HrXSqeYnpQQwzcSDd3Rk_gedXWlxEJwHdBAMeta } from "/codebuild/output/src2334194962/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d2Y1DB8xem0kuPwjTQTZojZ5OxSGkcZBcNwnsqU4Bz7cMeta } from "/codebuild/output/src2334194962/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmyLEQQ6Iy2YiyIKSlCohh74CMeVAHo3qEBWql2qJFUuUMeta } from "/codebuild/output/src2334194962/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexTSG34AncyhPhuy9MhbKCiydZSuInq6bNaS5YJT4lI_45oMeta } from "/codebuild/output/src2334194962/src/src/pages/card/create/index.vue?macro=true";
import { default as indexfTjM_n9GuyQ0ZwV92s1ECm3cx6O_I4YVL17ccCT2TqkMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmp114WpD7LCAcnI_R7m_k6KF_45R2Sd4HB1iPnjdUBQzkQMeta } from "/codebuild/output/src2334194962/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmkPsoxA6bd_45ZR0YKLAxYQoFVlQo6DrABBFvGCMb_9EJ8Meta } from "/codebuild/output/src2334194962/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete3fOKVjVWeprWaQv_45H_45KxuWURtgyNd6bmZcVggceKPiAMeta } from "/codebuild/output/src2334194962/src/src/pages/membership/complete.vue?macro=true";
import { default as register69RKqG13JxOB0WBpWxmuRJzUVTvAGwPDPh5Uyvoiyz4Meta } from "/codebuild/output/src2334194962/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93lw0kPvmP_lrBx2JvKOpwdWXxpiRdEQ7S4CgYRObaYBYMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmtreY2WK8ZkIXJOpG5iCfb5nLMd7CYEHZdaL1OmO1XYoMeta } from "/codebuild/output/src2334194962/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_933xyc9ztmudaswdemQNgrvAPnGn3ftzMZIwVobDLdrT4Meta } from "/codebuild/output/src2334194962/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexNmH_YVFUG9b2ydRnXIITooLNQwUwo_qNjDaHBBwwodoMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codegUOrd9PgtBO02xHSH2E6Xsi1VN4c3IFidr35yW9i3HYMeta } from "/codebuild/output/src2334194962/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codecSCr3_vta_45fObCKBwL9Kg2hWInfJecql2B9DqbFbBaEMeta } from "/codebuild/output/src2334194962/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeduVfgy7d0X90z1Pl5Ot0i9Xp9ohuVwLjJV_45OskD2FcUMeta } from "/codebuild/output/src2334194962/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerqVaoQ41sFcNFIM_45kVuKlANR_45ILVSycV66RhT2GGgsJYMeta } from "/codebuild/output/src2334194962/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete2i8w5468DErP1tascYcSClpFq4LN9HgnsLy27HyOHbAMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexRCafVZPNjvNzLoKTfD_45OnxZlnxD_6PWL8muurti4pTEMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmL27ehYB_rsPTGCDKANa6y2_gHk_45G5CpQ45l94LWmvZoMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeI2LjUpkxq1Qcgawis_QXiygkiMvUNDYpMD_45x2Lf0A7oMeta } from "/codebuild/output/src2334194962/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexYb_45TJL2ObiYonBm5qoKumVtov0xOxH4KaFtsHmbfeBUMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93OfEysIpE8_NYYgd6IFxHyauZUBadcoUy_45Y_45_YEB5N_AMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeLClw8eib4yGrJph5EhSDdyRHkfKbq2sTahDiAMUd6pMMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliashV89bI4a6egvSCX7II2uG9kIORrrZ1f7x_M9XLEIRhMMeta } from "/codebuild/output/src2334194962/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample4V7TwMm6zENuEWoT_459JXmQt7p8N7JNGKvCH8aj_gwP4Meta } from "/codebuild/output/src2334194962/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailTpr6F1sXdndwiZbCqAQfrRw_vu0vS__45R4IzspKFgXfwMeta } from "/codebuild/output/src2334194962/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmF61rDQVJ3CWHcxAYuAsmzLm_X6QuQdGJh3AeaTTaZIYMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent_45wJtWGQAoLjX4tkZwuKT_45aO8K75Xjvhj5rKFRsJQg7EMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm0k_qAcjA9ZAf0kr5tYEZkEgv1eLjdiUNdCkrmUxPrnEMeta } from "/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatehDE_0DkK1nmxEx5hGYu2XvVNBkNpR0t7fKhXEJDw890Meta } from "/codebuild/output/src2334194962/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completelW2RsJLiLS6HmM7iCoAi23hJd1MOJxOG6vcz6Tyk7GkMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeSAxZkyke505NTtxyEZz5pAespePtEBKXrRVi89oMPWkMeta } from "/codebuild/output/src2334194962/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordsumZUthpYgTjHQATOU0cmyCNko2y4_45bFMZRefFuVlkUMeta } from "/codebuild/output/src2334194962/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasRkPRapRtYzzscy60NdYKSLRX7PKJh7iA1dW_45l1y_91AMeta } from "/codebuild/output/src2334194962/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register5_JY5kimf_45tmFdkdfWuD9_459ehU5fZQ2nziQjlgcYNL8Meta } from "/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeSzvpkSVTvV7YuCnxo4OWBzBbjLyxQKUEePAW7icZsqgMeta } from "/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexf2lCEVVmbTokbM79Vp0wlh2UcLyr6ovR6MtuDQPZBHgMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index8rV6bJ0yvy24XNho8Fb4mKjb3NcMt9yXEmSBwTf7WXAMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexLW48vgye5b5F4UCe4dRhO1mwImVU37nzQ13t2a5wrN8Meta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexingrSpn_RbaRpEcZSpII_45yXvxM0jsbgYPYQxxGc1EqgMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateXW0yvUH5OnJY8KQ_5Jm4YDw1Ir7OkzfecnT7rACmIE0Meta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completevbq_4Em8789oHrxGidj1JunzMh8VqTC0ylqKtwfSAUYMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmoaeD86qjiLa5fG8v6ROlCljuOf_WpwY41OJu3cbthH8Meta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexhWadhHlwXEdR1x0RMiav1rt4AFMJWjvwvzqnOaLlyPUMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeV4DvGS_qN5ExTaVOE3l7LLskwUWOhz8yKsH4o7eHxr8Meta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateoOpaDxRBPO4ESR4uDqX02CdM1fU2K7EuzcWv4TUpyCYMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index04ApAojwf1rKqFrZzCSNoJX8bGkAjMJv1oiZ4nT7SecMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexZ7HG06igschewTWrS2u_xq6vFI12a07x37Iroup_BkEMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete9TfCtPcpdkauZpnLDOEXMzcVsrEb1kA6Rk8oAALZSPcMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexnhzBUgc3TLGpweW3MjDCYMlWEKNf3ONGkJ25ZJm1EGsMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeSGXU12tUkRj4a29q6JRXNqtHzSB7Z40uXauK_45k8rLOcMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexD8lFOPLEjzj0PWb4IKZCDnNQ1HOeizflRBHAK0ofJxgMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexM5RXuK_45fN3ArCdb09KHZmFAF4vvXbJYlLERvefvGh5YMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index7RZiemIYwpAT71hXoW5ux8WVj37anIjRb2Xz3ikoa0QMeta } from "/codebuild/output/src2334194962/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updategfMGz7YawUpzycbf_45PT7APcpmWoQX9cgmQ6oQqOfQQEMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm8ds_rsm9clXwxNPTyZ0yKO8xPs92gOslEcdYs4fEU2YMeta } from "/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuLL3w8MX2GXeE2T96lcXsv4cAvhMQogyTzthUZHCXSdAMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1pDc0ByRJtz6p37NdQN93wJL__8TVqdqVQtMyp4zzYgMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index5fJzqbIIoPpNDRcLavM1wuPhXBojEhD3Y2oiX3eAtMkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index3aa5TslLsZsTysasxfQ6ktTwQao87WkglGeieNjnC2cMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexVyD3Z9awfH8iMURNHTBOTawkDtqI5q19_45dYlFlHmTFcMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexdlOBfFsVtq_45agZchVQQvuN8qYnpY6rTI1Tk717kWIUEMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexTSG34AncyhPhuy9MhbKCiydZSuInq6bNaS5YJT4lI_45oMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmp114WpD7LCAcnI_R7m_k6KF_45R2Sd4HB1iPnjdUBQzkQMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmkPsoxA6bd_45ZR0YKLAxYQoFVlQo6DrABBFvGCMb_9EJ8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete3fOKVjVWeprWaQv_45H_45KxuWURtgyNd6bmZcVggceKPiAMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register69RKqG13JxOB0WBpWxmuRJzUVTvAGwPDPh5Uyvoiyz4Meta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmtreY2WK8ZkIXJOpG5iCfb5nLMd7CYEHZdaL1OmO1XYoMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codegUOrd9PgtBO02xHSH2E6Xsi1VN4c3IFidr35yW9i3HYMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codecSCr3_vta_45fObCKBwL9Kg2hWInfJecql2B9DqbFbBaEMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeduVfgy7d0X90z1Pl5Ot0i9Xp9ohuVwLjJV_45OskD2FcUMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerqVaoQ41sFcNFIM_45kVuKlANR_45ILVSycV66RhT2GGgsJYMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmL27ehYB_rsPTGCDKANa6y2_gHk_45G5CpQ45l94LWmvZoMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeI2LjUpkxq1Qcgawis_QXiygkiMvUNDYpMD_45x2Lf0A7oMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexYb_45TJL2ObiYonBm5qoKumVtov0xOxH4KaFtsHmbfeBUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeLClw8eib4yGrJph5EhSDdyRHkfKbq2sTahDiAMUd6pMMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample4V7TwMm6zENuEWoT_459JXmQt7p8N7JNGKvCH8aj_gwP4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailTpr6F1sXdndwiZbCqAQfrRw_vu0vS__45R4IzspKFgXfwMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmF61rDQVJ3CWHcxAYuAsmzLm_X6QuQdGJh3AeaTTaZIYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent_45wJtWGQAoLjX4tkZwuKT_45aO8K75Xjvhj5rKFRsJQg7EMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm0k_qAcjA9ZAf0kr5tYEZkEgv1eLjdiUNdCkrmUxPrnEMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completelW2RsJLiLS6HmM7iCoAi23hJd1MOJxOG6vcz6Tyk7GkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeSAxZkyke505NTtxyEZz5pAespePtEBKXrRVi89oMPWkMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordsumZUthpYgTjHQATOU0cmyCNko2y4_45bFMZRefFuVlkUMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register5_JY5kimf_45tmFdkdfWuD9_459ehU5fZQ2nziQjlgcYNL8Meta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeSzvpkSVTvV7YuCnxo4OWBzBbjLyxQKUEePAW7icZsqgMeta || {},
    component: () => import("/codebuild/output/src2334194962/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2334194962/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]